var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkloadForecast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 130,
    viewBox: "0 0 206 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.5 160.5H0.5V6C0.5 2.96243 2.96244 0.5 6 0.5H200C203.038 0.5 205.5 2.96244 205.5 6V160.5Z",
    fill: "#F3F3F3",
    stroke: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2414 39.7537C42.2825 39.7537 40.6946 41.3416 40.6946 43.3005V43.3005C40.6946 45.2593 42.2825 46.8473 44.2414 46.8473H162.419C164.378 46.8473 165.966 45.2593 165.966 43.3005V43.3005C165.966 41.3416 164.378 39.7537 162.419 39.7537H44.2414Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5 40C42.567 40 41 41.567 41 43.5V43.5C41 45.433 42.567 47 44.5 47H146.193C148.126 47 149.693 45.433 149.693 43.5V43.5C149.693 41.567 148.126 40 146.193 40H44.5Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.379 39.7537C176.42 39.7537 174.833 41.3416 174.833 43.3005V43.3005C174.833 45.2593 176.42 46.8473 178.379 46.8473H193.476C195.435 46.8473 197.023 45.2593 197.023 43.3005V43.3005C197.023 41.3416 195.435 39.7537 193.476 39.7537H178.379Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 53C28.5228 53 33 48.5228 33 43C33 37.4772 28.5228 33 23 33C17.4772 33 13 37.4772 13 43C13 48.5228 17.4772 53 23 53Z",
    fill: "#A6A8AB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8005 46.1018C25.759 46.1018 25.7175 46.0603 25.676 46.0603V46.0603C25.0536 45.8113 24.1822 45.3134 24.1822 44.608C24.1822 43.5292 25.427 43.3632 25.593 41.164C25.7175 39.3798 24.7631 38.0935 22.9789 38.0935C21.1947 38.0935 20.2403 39.3798 20.3648 41.164C20.5308 43.4047 21.7756 43.5707 21.7756 44.608C21.7756 45.3134 20.9042 45.8113 20.2818 46.0603V46.0603C20.2403 46.0603 20.1988 46.1018 20.1573 46.1018C19.8254 46.2678 19.5764 46.6412 19.5764 47.0562C19.5764 47.6371 20.0328 48.0935 20.6138 48.0935H22.9789H25.3441C25.925 48.0935 26.3814 47.6371 26.3814 47.0562C26.4229 46.6412 26.1739 46.2678 25.8005 46.1018V46.1018Z",
    fill: "#BBBDBF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2414 67.7537C42.2825 67.7537 40.6946 69.3416 40.6946 71.3005V71.3005C40.6946 73.2593 42.2825 74.8473 44.2414 74.8473H162.419C164.378 74.8473 165.966 73.2593 165.966 71.3005V71.3005C165.966 69.3416 164.378 67.7537 162.419 67.7537H44.2414Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5 68C42.567 68 41 69.567 41 71.5V71.5C41 73.433 42.567 75 44.5 75H65.4211C67.3541 75 68.9211 73.433 68.9211 71.5V71.5C68.9211 69.567 67.3541 68 65.4211 68H44.5Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.379 67.7537C176.42 67.7537 174.833 69.3416 174.833 71.3005V71.3005C174.833 73.2593 176.42 74.8473 178.379 74.8473H193.476C195.435 74.8473 197.023 73.2593 197.023 71.3005V71.3005C197.023 69.3416 195.435 67.7537 193.476 67.7537H178.379Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 81C28.5228 81 33 76.5228 33 71C33 65.4772 28.5228 61 23 61C17.4772 61 13 65.4772 13 71C13 76.5228 17.4772 81 23 81Z",
    fill: "#A6A8AB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8005 74.1018C25.759 74.1018 25.7175 74.0603 25.676 74.0603V74.0603C25.0536 73.8113 24.1822 73.3134 24.1822 72.608C24.1822 71.5292 25.427 71.3632 25.593 69.164C25.7175 67.3798 24.7631 66.0935 22.9789 66.0935C21.1947 66.0935 20.2403 67.3798 20.3648 69.164C20.5308 71.4047 21.7756 71.5707 21.7756 72.608C21.7756 73.3134 20.9042 73.8113 20.2818 74.0603V74.0603C20.2403 74.0603 20.1988 74.1018 20.1573 74.1018C19.8254 74.2678 19.5764 74.6412 19.5764 75.0562C19.5764 75.6371 20.0328 76.0935 20.6138 76.0935H22.9789H25.3441C25.925 76.0935 26.3814 75.6371 26.3814 75.0562C26.4229 74.6412 26.1739 74.2678 25.8005 74.1018V74.1018Z",
    fill: "#BBBDBF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2414 95.7537C42.2825 95.7537 40.6946 97.3416 40.6946 99.3005V99.3005C40.6946 101.259 42.2825 102.847 44.2414 102.847H162.419C164.378 102.847 165.966 101.259 165.966 99.3005V99.3005C165.966 97.3416 164.378 95.7537 162.419 95.7537H44.2414Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5 96C42.567 96 41 97.567 41 99.5V99.5C41 101.433 42.567 103 44.5 103H131.235C133.168 103 134.735 101.433 134.735 99.5V99.5C134.735 97.567 133.168 96 131.235 96H44.5Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.379 95.7537C176.42 95.7537 174.833 97.3416 174.833 99.3005V99.3005C174.833 101.259 176.42 102.847 178.379 102.847H193.476C195.435 102.847 197.023 101.259 197.023 99.3005V99.3005C197.023 97.3416 195.435 95.7537 193.476 95.7537H178.379Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 109C28.5228 109 33 104.523 33 99C33 93.4772 28.5228 89 23 89C17.4772 89 13 93.4772 13 99C13 104.523 17.4772 109 23 109Z",
    fill: "#A6A8AB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8005 102.102C25.759 102.102 25.7175 102.06 25.676 102.06V102.06C25.0536 101.811 24.1822 101.313 24.1822 100.608C24.1822 99.5292 25.427 99.3632 25.593 97.164C25.7175 95.3798 24.7631 94.0935 22.9789 94.0935C21.1947 94.0935 20.2403 95.3798 20.3648 97.164C20.5308 99.4047 21.7756 99.5707 21.7756 100.608C21.7756 101.313 20.9042 101.811 20.2818 102.06V102.06C20.2403 102.06 20.1988 102.102 20.1573 102.102C19.8254 102.268 19.5764 102.641 19.5764 103.056C19.5764 103.637 20.0328 104.094 20.6138 104.094H22.9789H25.3441C25.925 104.094 26.3814 103.637 26.3814 103.056C26.4229 102.641 26.1739 102.268 25.8005 102.102V102.102Z",
    fill: "#BBBDBF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2414 123.754C42.2825 123.754 40.6946 125.342 40.6946 127.3V127.3C40.6946 129.259 42.2825 130.847 44.2414 130.847H162.419C164.378 130.847 165.966 129.259 165.966 127.3V127.3C165.966 125.342 164.378 123.754 162.419 123.754H44.2414Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5 124C42.567 124 41 125.567 41 127.5V127.5C41 129.433 42.567 131 44.5 131H119.269C121.202 131 122.769 129.433 122.769 127.5V127.5C122.769 125.567 121.202 124 119.269 124H44.5Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.379 123.754C176.42 123.754 174.833 125.342 174.833 127.3V127.3C174.833 129.259 176.42 130.847 178.379 130.847H193.476C195.435 130.847 197.023 129.259 197.023 127.3V127.3C197.023 125.342 195.435 123.754 193.476 123.754H178.379Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 137C28.5228 137 33 132.523 33 127C33 121.477 28.5228 117 23 117C17.4772 117 13 121.477 13 127C13 132.523 17.4772 137 23 137Z",
    fill: "#A6A8AB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8005 130.102C25.759 130.102 25.7175 130.06 25.676 130.06V130.06C25.0536 129.811 24.1822 129.313 24.1822 128.608C24.1822 127.529 25.427 127.363 25.593 125.164C25.7175 123.38 24.7631 122.094 22.9789 122.094C21.1947 122.094 20.2403 123.38 20.3648 125.164C20.5308 127.405 21.7756 127.571 21.7756 128.608C21.7756 129.313 20.9042 129.811 20.2818 130.06V130.06C20.2403 130.06 20.1988 130.102 20.1573 130.102C19.8254 130.268 19.5764 130.641 19.5764 131.056C19.5764 131.637 20.0328 132.094 20.6138 132.094H22.9789H25.3441C25.925 132.094 26.3814 131.637 26.3814 131.056C26.4229 130.641 26.1739 130.268 25.8005 130.102V130.102Z",
    fill: "#BBBDBF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 206,
    height: 130,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkloadForecast);
export default __webpack_public_path__ + "static/media/WorkloadForecast.d9f84075e7426e6e949d33eb3ea338ab.svg";
export { ForwardRef as ReactComponent };